import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';
import { AnnouncementWithTestId, AnnouncementsState } from './types';

export const announcementsState = proxy<AnnouncementsState>({
  announcements: {},
});

valtioDevTools(announcementsState, 'announcementsState');

class AnnouncementsModule extends AppModule {
  /** @deprecated Prefer mounting a hook and rendering inline in `<Announcements>`. */
  public showAnnouncement(announcement: AnnouncementWithTestId, key: string) {
    announcementsState.announcements = {
      ...announcementsState.announcements,
      [key]: announcement,
    };
  }

  /** @deprecated See `showAnnouncement`. */
  public hideAnnouncement(key: string) {
    delete announcementsState.announcements[key];
  }
}

export default new AnnouncementsModule(
  appManager.events,
  appManager.logger('Announcements'),
);
